import React from 'react';
import VersionListing from '../version-listing';
import type { Version } from '../version-listing/version-listing';
import type { GqlProductVersion } from '../../../../../content/types/content/product-version';

const productVersionToVersion = (
    productVersion: GqlProductVersion
): Version => {
    let versionName = `${productVersion.product.productName} ${productVersion.platform}`;
    if (
        productVersion.platform === 'Data Center' &&
        productVersion.product.productName === 'Jira Align'
    ) {
        versionName = 'Jira Align Self Hosted';
    }
    return {
        ...productVersion,
        id: productVersion.sys.id,
        name: versionName
    };
};

const ProductVersions = ({
    productVersions
}: {
    productVersions: GqlProductVersion[];
}) => {
    return (
        <VersionListing
            title={'App' + (productVersions.length > 1 ? 's' : '')}
            versions={productVersions.map(productVersionToVersion)}
        />
    );
};

export default ProductVersions;
